import React from 'react';
import { Link } from 'react-router-dom';
import Typography from '@navi/web-ui/lib/primitives/Typography';
import { Popper, PopperContent, PopperTrigger } from '../../../Popper/Popper';
import styles from '../index.module.scss';
import cx from 'classnames';
import MoreNavBarIcon from '@cp/src/assets/icons/MoreNavBarIcon';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { clickStreamEvent } from '@cp/src/components/sidebar/NavigationLinks/interface';
import { MORE_MENU_KEY } from '../utils';

interface MoreMenuItemsProps {
  selectedMoreItem?: GenericObject;
  moreMenuItems: GenericObject[];
  currentPathname: string;
  isSidebarBlocked?: boolean;
  linkClickHandler: (event: clickStreamEvent) => void;
  clickStreamEvent: clickStreamEvent;
}

const MoreMenuItems: React.FC<MoreMenuItemsProps> = ({
  selectedMoreItem,
  moreMenuItems,
  currentPathname,
  isSidebarBlocked,
  linkClickHandler,
  clickStreamEvent
}) => {
  const displayName = selectedMoreItem ? selectedMoreItem.name : MORE_MENU_KEY;

  return (
    <Popper>
      <PopperTrigger>
        <div
          className={cx(styles.sideNavBarLinks, {
            active: selectedMoreItem,
            '!cursor-not-allowed': isSidebarBlocked
          })}
          onClick={() => {
            if (!isSidebarBlocked) {
              linkClickHandler(clickStreamEvent);
            }
          }}
        >
          <MoreNavBarIcon />
          <Typography variant="h4" className={cx([styles.text, styles.showText])}>
            {displayName}
          </Typography>
        </div>
      </PopperTrigger>
      {!isSidebarBlocked && (
        <PopperContent className="z-10" iconRequired={false}>
          {({ closePopper }) => (
            <div className={styles.moreMenuContainer}>
              {moreMenuItems.map(item => (
                <Link
                  key={item.route}
                  to={item.route}
                  className={cx(
                    styles.moreMenuItem,
                    currentPathname.includes(item.route) && styles.selectedMoreItem
                  )}
                  onClick={() => {
                    if (item.clickStreamEvent) {
                      linkClickHandler(item.clickStreamEvent);
                    }
                    closePopper();
                  }}
                >
                  <div className="flex flex-row items-center justify-center">
                    <div className={styles.iconWrapper}>
                      {currentPathname.includes(item.route) ? item.activeIcon : item.inActiveIcon}
                    </div>
                    <Typography variant="p5" color="var(--navi-color-gray-bg-primary)">
                      {item.name}
                    </Typography>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </PopperContent>
      )}
    </Popper>
  );
};

export default MoreMenuItems;
